/**
 * Feature Flag Constants
 * 
 * Central location for all feature flag keys used across the application.
 * Keep this file in sync with your PostHog feature flag configuration.
 */

/**
 * Feature flag keys for the application
 */
export const FeatureFlags = {
    EXPERIENCE_SELECTION: 'experience-selection-screen',
    PROFILE_ONBOARDING: 'profile-onboarding-screen',
    HOME_ONBOARDING: 'home-onboarding-screen',
    GROUP_ONBOARDING: 'group-onboarding-screen',
    HOME_ROUTER: 'home-router-screen',
    GROUP_INVITES: 'group-invites-screen',
    HOME_INVITES: 'home-invites-screen',
    PROFILE_LAYOUT: 'profile-layout-screen',
    PROFILE_ACCOUNT: 'profile-account-screen',
    PROFILE_HOMES: 'profile-homes-screen',
    PROFILE_NOTIFICATIONS: 'profile-notifications-screen',
    PROFILE_CALENDAR: 'profile-calendar-screen',
    GROUP_DETAILS: 'group-details-screen',
    GROUP_PREFERENCES: 'group-preferences-screen',
    GROUP_PREFERENCES_DETAILS: 'group-preferences-details-screen',
    GROUP_PREFERENCES_MEMBERS: 'group-preferences-members-screen',
    GROUP_PREFERENCES_MINE: 'group-preferences-mine-screen',
    GROUP_LISTING_DETAILS: 'group-listing-details-screen',
    GROUP_BILLING: 'group-billing-screen',
    HOME_OVERVIEW: 'home-overview-screen',
    HOME_PREFERENCES: 'home-preferences-screen',
    HOME_PREFERENCES_GENERAL: 'home-preferences-general-screen',
    HOME_PREFERENCES_ADDRESS: 'home-preferences-address-screen',
    HOME_PREFERENCES_PROPERTY: 'home-preferences-property-screen',
    HOME_PREFERENCES_MEMBERS: 'home-preferences-members-screen',
    HOME_PREFERENCES_BOOKING: 'home-preferences-booking-screen',
    HOME_PREFERENCES_FINANCE: 'home-preferences-finance-screen',
    HOME_PREFERENCES_INTEGRATIONS: 'home-preferences-integrations-screen',
    HOME_BILLING: 'home-billing-screen',
    HOME_ACTIVITY: 'home-activity-screen',
    GROUP_ACTIVITY: 'group-activity-screen',
    HOME_PREFERENCES_ACTIVITY: 'home-preferences-activity-screen',
    GROUP_PREFERENCES_ACTIVITY: 'group-preferences-activity-screen',
    HOME_EXPENSES: 'home-expenses-screen',
    HOME_DOCUMENTS: 'home-documents-screen',
    HOME_SCHEDULE: 'home-schedule-screen',
    HOME_ASSETS: 'home-assets-screen',
    ALPHA_BANNER: 'alpha-banner',
} as const;

/**
 * Type for feature flag keys
 */
export type FeatureFlagKey = typeof FeatureFlags[keyof typeof FeatureFlags];
